import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translations
import en from './i18n/locales/en.json';
import es from './i18n/locales/es.json';
import ru from './i18n/locales/ru.json';
import vi from './i18n/locales/vi.json';
import id from './i18n/locales/id.json';
import az from './i18n/locales/az.json';
import th from './i18n/locales/th.json';

const resources = {
    en: { translation: en },
    es: { translation: es },
    ru: { translation: ru },
    vi: { translation: vi },
    id: { translation: id },
    az: { translation: az },
    th: { translation: th },
};

const supportedLngs = Object.keys(resources);

// Detect language from Telegram WebApp (required by TAC)
// Falls back to 'en' if not in Telegram or language not supported
function getTelegramLanguage(): string {
    try {
        const tg = (window as any).Telegram?.WebApp;
        // Try multiple sources of language
        const langFromUser = tg?.initDataUnsafe?.user?.language_code;
        const langFromWebApp = tg?.language;  // WebApp.language property
        const lang = langFromUser || langFromWebApp;

        console.log('[i18n] Telegram language detection:', {
            langFromUser,
            langFromWebApp,
            resolved: lang,
            supported: lang ? supportedLngs.includes(lang) : false,
        });

        if (lang && supportedLngs.includes(lang)) return lang;
    } catch (e) {
        console.warn('[i18n] Telegram language detection failed:', e);
    }
    return 'en';
}

// Remove stale localStorage cache from old browser language detector
// Without this, old cached 'es' would override our Telegram detection
try { localStorage.removeItem('i18nextLng'); } catch { /* SSR safe */ }

const detectedLng = getTelegramLanguage();
console.log('[i18n] Using language:', detectedLng);

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: detectedLng,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
